var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.Component, {
    ref: "componentParent",
    tag: "component",
    on: {
      removeMultipleForm: _vm.handleRemoveMultipleForm,
      firstFetch: _vm.firstFetchDataApply,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ data, loading, filter }) {
          return [
            _c(
              "el-tabs",
              {
                staticStyle: { "margin-top": "20px" },
                attrs: { "tab-position": "top", type: "card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { name: "form" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("Danh sách phiếu"),
                    ]),
                    _c("DataTableSurveyForm", {
                      ref: "dataTableSurveyForm",
                      attrs: {
                        tab: "survey_form",
                        "data-table-survey-form": data,
                        "is-loading": loading,
                      },
                      on: { resetData: _vm.handleResetData },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "apply" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("Danh sách áp dụng"),
                    ]),
                    _c("DataTableAppliesSurveyForm", {
                      ref: "dataTableAppliesSurveyForm",
                      attrs: { tab: "apply_form", "data-form-filter": filter },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }